import "../lib/bootstrap-css";
import React from "react";
import Head from "next/head";

const TermsAndConditions = () => {
	return (
		<div>
			<div>
				<Head>
					<meta charSet="UTF-8" />
					<meta name="viewport" content="width=device-width, initial-scale=1" />
					<link
						rel="shortcut icon"
						type="image/png"
						href="/images/tu-favicon.png"
					/>
					<title>Terms &amp; Conditions</title>
					<meta
						name="description"
						content="Terms & Conditions for Technical Union website use, communications, and WhatsApp messaging."
					/>
					<meta name="author" content="Edgar Lindo" />
				</Head>
			</div>
			<br />
			<div className="col-md-12">
				<h1>Terms &amp; Conditions</h1>
				<p>
					<b>Effective Date:</b> September 16, 2026
				</p>
				<p>
					Welcome to Technical Union (TU). These Terms &amp; Conditions govern
					your use of the Technical Union website and your communications and
					interactions with Technical Union.
				</p>
			</div>

			<div className="col-md-12">
				<b>1. General</b>
				<p>
					Technical Union (&quot;TU,&quot; &quot;we,&quot; &quot;us,&quot; or
					&quot;our&quot;) provides industrial products, components, technical
					information, sales assistance, and related services.
				</p>
				<p>
					By using our website, submitting an inquiry, requesting information,
					or otherwise communicating with Technical Union, you agree to these
					Terms &amp; Conditions.
				</p>
			</div>

			<div className="col-md-12">
				<b>2. Contact and Communications</b>
				<p>
					When you provide your contact information to Technical Union, you may
					be contacted regarding your inquiry, requested information, products,
					services, quotations, orders, customer support, or other related
					business matters.
				</p>
				<p>
					Depending on the nature of the communication and the information you
					provide, Technical Union may contact you by email, telephone,
					WhatsApp, or other appropriate communication methods.
				</p>
				<p>
					You may request that Technical Union stop contacting you for marketing
					or promotional purposes at any time.
				</p>
			</div>

			<div className="col-md-12">
				<b>3. Email Communications</b>
				<p>
					If you voluntarily provide your email address and request information
					from Technical Union, we may use your email address to respond to your
					inquiry and provide information related to our products and services.
				</p>
				<p>
					Where applicable, you may unsubscribe from promotional email
					communications by using the unsubscribe option provided in the email
					or by contacting us at{" "}
					<a href="mailto:info@tu.biz">info@tu.biz</a>.
				</p>
			</div>

			<div className="col-md-12">
				<b>4. WhatsApp Messaging Terms</b>
				<p>
					<b>WhatsApp Messaging Program</b>
				</p>
				<p>
					<b>Registered Brand Name:</b> Technical Union (TU)
				</p>
				<p>
					By opting in to receive WhatsApp messages from Technical Union (TU),
					you agree to receive WhatsApp communications related to your
					inquiries, product requests, quotations, products, services, customer
					support, orders, and other related business communications.
				</p>
				<p>Message frequency varies.</p>
				<p>Message and data rates may apply.</p>
				<p>
					Your consent to receive WhatsApp messages is not a condition of
					purchasing any goods or services from Technical Union.
				</p>
				<p>
					You may stop receiving WhatsApp messages at any time by replying STOP.
					After you request to opt out, Technical Union will stop sending
					WhatsApp messages to that number, except where a message is necessary
					to process or respond to an existing business transaction or request.
				</p>
				<p>
					For assistance, reply HELP or contact us at{" "}
					<a href="mailto:info@tu.biz">info@tu.biz</a>.
				</p>
				<p>
					Technical Union does not sell or share mobile telephone numbers or
					WhatsApp opt-in information with third parties or affiliates for their
					own marketing or promotional purposes.
				</p>
				<p>
					Technical Union is not responsible for delayed or undelivered WhatsApp
					messages.
				</p>
			</div>

			<div className="col-md-12">
				<b>5. Consent</b>
				<p>
					Where consent is required, you provide consent voluntarily by
					submitting your information and/or selecting the applicable
					communication or messaging opt-in.
				</p>
				<p>
					You may withdraw your consent for marketing communications at any time
					using the available unsubscribe or opt-out methods.
				</p>
				<p>
					Withdrawing consent to receive marketing communications does not
					affect communications necessary to complete an existing transaction,
					respond to an inquiry, provide requested services, or otherwise
					fulfill a business relationship.
				</p>
			</div>

			<div className="col-md-12">
				<b>6. Website Content</b>
				<p>
					The information provided on this website is intended for general
					informational purposes. Technical Union makes reasonable efforts to
					provide accurate and current information but does not guarantee that
					all information, specifications, pricing, availability, or other
					website content is complete, current, or error-free.
				</p>
				<p>
					Product specifications, availability, pricing, and delivery
					information may change without notice.
				</p>
			</div>

			<div className="col-md-12">
				<b>7. Product and Service Inquiries</b>
				<p>
					Submitting an inquiry through the website does not constitute an
					order, purchase agreement, quotation acceptance, or binding contract.
				</p>
				<p>
					Any quotation, purchase, or sale is subject to the applicable terms
					provided by Technical Union.
				</p>
			</div>

			<div className="col-md-12">
				<b>8. Third-Party Services</b>
				<p>
					Technical Union may use third-party services and communication
					platforms, including email providers, WhatsApp, and other technology
					providers, to facilitate communications and provide services.
				</p>
				<p>
					Your use of third-party communication platforms may also be subject to
					the terms and privacy policies of those providers.
				</p>
			</div>

			<div className="col-md-12">
				<b>9. Privacy</b>
				<p>
					Technical Union&apos;s collection and use of personal information is
					described in our{" "}
					<a href="https://www.tu.biz/privacy-policy">Privacy Policy</a>.
				</p>
				<p>
					By using our website or providing information to Technical Union, you
					acknowledge that your information may be handled in accordance with
					our Privacy Policy.
				</p>
			</div>

			<div className="col-md-12">
				<b>10. Changes to These Terms</b>
				<p>
					Technical Union may update these Terms &amp; Conditions from time to
					time. Changes will be posted on this page with an updated effective
					date.
				</p>
			</div>

			<div className="col-md-12">
				<b>11. Contact Us</b>
				<p>
					If you have questions regarding these Terms &amp; Conditions or our
					communications, please contact:
				</p>
				<ul>
					<li>
						<b>Technical Union (TU)</b>
					</li>
					<li>
						<b>Email:</b>{" "}
						<a href="mailto:info@tu.biz">info@tu.biz</a>
					</li>
					<li>
						<b>Website:</b>{" "}
						<a href="https://www.tu.biz">https://www.tu.biz</a>
					</li>
				</ul>
				<p>Technical Union (TU)</p>
				<p>All rights reserved.</p>
			</div>
		</div>
	);
};

export default TermsAndConditions;
